import React from "react";

export const ShopHero = () => {
  return (
    <section className="bg-[#F5E3EA] py-8 md:py-12 w-full">
      <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
        <div className="max-w-3xl space-y-3">
          <span className="inline-block bg-white/60 text-[#380C1E]/70 font-semibold text-xs uppercase tracking-widest px-4 py-1.5 rounded-full border border-[#E8DEC8]">
            The Shop
          </span>
          <h1 className="font-serif text-2xl sm:text-4xl lg:text-5xl font-normal text-[#380C1E] leading-[1.1]">
            Tools for the woman who is done surviving and ready to steward what
            God placed in her hands.
          </h1>
          <p className="text-sm md:text-base text-[#380C1E]/70 max-w-2xl font-light leading-relaxed">
            Whether you need clarity, structure, a reset, or guided support,
            your next step toward becoming starts here.
          </p>
        </div>
      </div>
    </section>
  );
};
